import type { MissingSkuReason, SearchedBy } from '../types/stockImports.types'

export const MISSING_SKU_REASON_LABELS: Record<MissingSkuReason, string> = {
  NO_ARTICLE: 'Нет артикула, артикула поставщика и штрихкода',
  NO_BRAND: 'Не указан бренд: без бренда товар по артикулу не ищется',
  NO_QUANTITY: 'Не указано количество',
  INVALID_QUANTITY: 'Количество не распознано',
  INVALID_ARTICLE_LENGTH: 'Невалидный артикул (длина больше 30 символов)',
  NOT_FOUND: 'Товар не найден в каталоге',
  NOT_FOUND_NARROWED:
    'Найден товар с таким артикулом, но другого бренда (или бренд из файла неизвестен — добавьте синоним)',
  CONFLICT: 'Найдено несколько товаров, однозначное сопоставление невозможно',
  BRAND_BLACKLISTED: 'Исключено фильтром: бренд в чёрном списке',
  BRAND_NOT_WHITELISTED: 'Исключено фильтром: бренда нет в разрешённом списке',
}

/**
 * Текст причины для интерфейса. Неизвестный код показываем как есть:
 * бэкенд может добавить значение в enum раньше, чем фронт о нём узнает,
 * и пустая ячейка вместо причины хуже, чем сырой код.
 */
export function formatMissingSkuReason(
  reason?: MissingSkuReason | string | null,
  searchedBy?: readonly SearchedBy[] | null
): string {
  if (!reason) return ''
  if (reason === 'NOT_FOUND' && searchedBy?.includes('BARCODE')) {
    return 'Товар не найден в каталоге по штрихкоду и артикулу'
  }
  return MISSING_SKU_REASON_LABELS[reason as MissingSkuReason] ?? String(reason)
}

export const getArchiveConfigWarning = (storeName: string | undefined) =>
  `Остатки склада${storeName ? ` «${storeName}»` : ''} будут удалены из поиска. После восстановления из архива их нужно будет загрузить заново.`

export const RESET_CHECKS_WARNING =
  'Используйте, если настройку завели под новый файл или новые колонки. Защиты загрузки (падение числа позиций относительно обычного, рост доли ненайденных, скачки цен) начнут считаться заново, с первой загрузки после сброса. Журнал загрузок, остатки и цены склада сохранятся, последний файл загрузится ещё раз.'

export const STOCK_IMPORT_PROGRESS_MESSAGES = {
  validateUrl:
    'Проверяем ссылку и скачиваем файл. Для тяжёлых прайсов это может занять несколько минут...',
  preview:
    'Сканируем структуру файла для предпросмотра. Для тяжелых прайсов это может занять несколько минут...',
  trial:
    'Выполняем пробную загрузку без сохранения остатков. Загрузка большого файла и поиск товаров в каталоге могут занять несколько минут...',
  manual:
    'Запускаем обновление остатков. Загрузка файла и обновление каталога могут занять несколько минут. Результат появится здесь и в Журнале загрузок.',
} as const

export const STOCK_IMPORT_RUN_MESSAGES = {
  liveTitle: 'Запуск с сохранением остатков',
  liveWarning:
    'Внимание! Все остатки выбранного склада будут перезаписаны результатами этой загрузки.',
} as const

export const STOCK_IMPORT_LIVE_CONFIRMATION = {
  title: STOCK_IMPORT_RUN_MESSAGES.liveTitle,
  content: STOCK_IMPORT_RUN_MESSAGES.liveWarning,
  okText: 'Запустить',
  cancelText: 'Отмена',
  danger: true,
} as const
